<template>
  <div class="bbp-large-text-cell"
       @mouseenter="setShowReason($event, true)"
       @mouseleave="showReason = false"
  >
    <span class="bbp-large-text-cell__item">{{reason}}</span>
    <transition name="bbp-bounce">
      <div class="bbp-large-text-cell__popup"
           :style="reasonInfo"
           v-if="showReason"
      >
        <div v-for="reason in reasons"
             class="bbp-large-text-cell__text"
             :key="reason"
        >
          {{reason}}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
export default {
  name: 'BBPLargeTextCell',
  props: ['row', 'column', 'index'],
  computed: {
    reason () {
      const value = get(this.row, this.column.prop, [])
      return value[0]
    },
    reasons () {
      return get(this.row, this.column.prop, [])
    }
  },
  data () {
    return {
      showReason: false,
      reasonInfo: {}
    }
  },
  methods: {
    setShowReason (e, val) {
      this.showReason = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.reasonInfo = {
          position: 'fixed',
          top: position.top + position.height + 8 + 'px',
          right: 70 + 'px'
        }
      } else {
        this.reasonInfo = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-large-text-cell {
    @include global-font;
    position: relative;

    &__item {
      width: 100%;
      overflow: hidden;
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__text {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      margin-bottom: 12px;
      line-height: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__popup {
      pointer-events: none;
      max-width: 324px;
      width: 100%;
      padding: 16px;
      background: $color-white;
      border-radius: 4px;
      box-shadow: 0 0 12px rgba($color-black, 0.12);
      z-index: 4;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPLargeTextCell/BBPLargeTextCell.vue